import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { Task } from '../../../../../helpers/task';

@Component({
    selector: 'tcm-linked-search-layout',
    templateUrl: './tcm-linked-search-layout.component.html',
    styleUrls: ['./tcm-linked-search-layout.component.scss'],
    standalone: false
})
export class TcmLinkedSearchLayoutComponent {

    @Input() titleKey: string;

    @Input() isLoading: boolean;

    @Input() useAdvancedSearch: boolean = false;

    showRightSidebar: boolean;

    @ViewChild('rightSideBarContainer', { static: true }) rightSideBarContainer: ElementRef<HTMLElement>;

    async toggleRightSideBar($event: Event) {
        $event.stopPropagation();

        this.showRightSidebar = !this.showRightSidebar;

        if (this.showRightSidebar) {
            await Task.delay(600);
        }
        
        if (this.showRightSidebar) {
            this.rightSideBarContainer.nativeElement.classList.add('omit-overflow');
        }
        else {
            this.rightSideBarContainer.nativeElement.classList.remove('omit-overflow');
        }
    }
}
